/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AlignItero from './AlignItero/index'
import CaptureImageRequest from './CaptureImageRequest/index'
import CephTracing from './CephTracing/index'
import CreateIteroScanRequest from './CreateIteroScanRequest/index'
import DownloadAction from './DownloadAction/index'
import ITeroCheckPatientConnection from './ITeroCheckPatientConnection/index'
import ImageSeriesLauncherProps from './ImageSeriesLauncherProps/index'
import Images from './Images/index'
import ImportAction from './ImportAction/index'
import ImportFromDevices from './ImportFromDevices/index'
import ImportFromInvisalignPracticeApp from './ImportFromInvisalignPracticeApp/index'
import LayoutOptions from './LayoutOptions/index'
import MoreActions from './MoreActions/index'
import React from 'react'
import TracedCephAction from './TracedCephAction/index'
import UploadFromDesktop from './UploadFromDesktop/index'
import UploadVideo from './UploadVideo/index'
import UploadedImages from './UploadedImages/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral200,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<LayoutOptions
  viewPath={`${viewPath}/LayoutOptions`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TracedCephAction
  viewPath={`${viewPath}/TracedCephAction`}
/>
<ImportAction
  viewPath={`${viewPath}/ImportAction`}
/>
<DownloadAction
  viewPath={`${viewPath}/DownloadAction`}
/>
<MoreActions
  viewPath={`${viewPath}/MoreActions`}
/>
</div>
</div>
<AlignItero
  viewPath={`${viewPath}/AlignItero`}
/>
<Images
  viewPath={`${viewPath}/Images`}
/>
<UploadedImages
  viewPath={`${viewPath}/UploadedImages`}
/>
<CaptureImageRequest
  viewPath={`${viewPath}/CaptureImageRequest`}
/>
<UploadFromDesktop
  viewPath={`${viewPath}/UploadFromDesktop`}
/>
<UploadVideo
  viewPath={`${viewPath}/UploadVideo`}
/>
<ImportFromDevices
  viewPath={`${viewPath}/ImportFromDevices`}
/>
<CephTracing
  viewPath={`${viewPath}/CephTracing`}
/>
<ImportFromInvisalignPracticeApp
  viewPath={`${viewPath}/ImportFromInvisalignPracticeApp`}
/>
<CreateIteroScanRequest
  viewPath={`${viewPath}/CreateIteroScanRequest`}
/>
<ImageSeriesLauncherProps
  viewPath={`${viewPath}/ImageSeriesLauncherProps`}
/>
<ITeroCheckPatientConnection
  viewPath={`${viewPath}/ITeroCheckPatientConnection`}
/>
{children}
</React.Fragment>)
}